import { useState, useEffect } from 'react';
import { useBackendSettings } from './useBackendSettings';

export const useStoryTimeTour = () => {
  const [showTour, setShowTour] = useState(false);
  const { settings, saveSettings, isLoading: isLoadingSettings } = useBackendSettings();

  useEffect(() => {
    // Wait for settings to load from backend before deciding whether to show tour
    if (isLoadingSettings) {
      return;
    }

    // Check if user has completed the tour
    const hasCompletedTour = settings?.storytime_tour_completed === 'true';

    // Show tour automatically if never completed
    if (!hasCompletedTour) {
      setShowTour(true);
    } else {
      setShowTour(false);
    }
  }, [settings, isLoadingSettings]);

  const completeTour = () => {
    saveSettings({
      storytime_tour_completed: 'true',
      storytime_tour_skipped: 'false',
    });
    setShowTour(false);
  };

  const skipTour = () => {
    // Mark as skipped but not completed, so the tour re-offers on next visit
    saveSettings({ storytime_tour_skipped: 'true' });
    setShowTour(false);
  };

  const resetTour = () => {
    saveSettings({
      storytime_tour_completed: 'false',
      storytime_tour_skipped: 'false',
    });
    setShowTour(true);
  };

  // Check if tour was skipped but never completed (parity with the other
  // tour hooks' return shape)
  const wasSkipped =
    settings?.storytime_tour_skipped === 'true' &&
    settings?.storytime_tour_completed !== 'true';

  return {
    showTour,
    isLoading: isLoadingSettings,
    completeTour,
    skipTour,
    resetTour,
    wasSkipped,
  };
};
